export default "__VITE_ASSET__Cnf4KC2n__"